(function () {
  'use strict';

  angular
    .module('app.autocomplete-select', ['angucomplete-alt'])

    .directive('autoCompleteSelect', function () {
      return {
        restrict: 'E',
        scope: true,
        bindToController: {
          device: '<',
          action: '&',
          txtAddToList: '@',
          txtViewAndChoose: '@',
          onlyAllowAddToCart: '<?'
        },
        controllerAs: 'searchCtrl',
       /* @ngInject */
        controller: ["$element", "$window", "$http", "$timeout", "$sce", "WindowEventsService", function ($element, $window, $http, $timeout, $sce, WindowEventsService) {
          var ctrl = this;

          ctrl.$onInit = function () {
            $timeout(function () {
              resize();
            }, 1000);
          };

          ctrl.searchAPI = function (userInputString, timeoutPromise) {
            return $http.post('/Search/AutoCompleteQuery', {
              QueryFullText: userInputString,
              CategoryId: '',
              NbFrom: '0',
              NbSize: '50',
              withCatalogs: false
            }, {timeout: timeoutPromise});
          };

          ctrl.getResponse = function (data, str) {
            ctrl.products = _.filter(data.results, function (res) {
              if (ctrl.onlyAllowAddToCart && !res.AllowAddToCart && !res.IsGroupingProduct) {
                return false;
              }

              return res.KeyWebAspect === 'Default';
            });

            _.each(ctrl.products, function (value, key) {
              ctrl.products[key].designationHtml = findMatchString(ctrl.products[key].Designation, str);
            });

            $timeout(function () {
              $element.find('.dropdown-menu, .scroll-container').scrollTop(0);
              $element.find('.dropdown-menu.with-img').trigger('scroll');
            }, 100);

            return data;
          };

          ctrl.clearResults = function () {
            ctrl.products = null;
          };

          ctrl.searchCallback = function (selected) {
            selected.IsElementary = false;
            ctrl.action({product: selected});
          };

          WindowEventsService.listen(true, 'scroll', resize, 500);

          ctrl.$onDestroy = function () {
            WindowEventsService.listen(false, 'scroll', resize);
          };

            // Functions

          function resize() {
            $timeout(function () {
              var maxHeight = Math.floor($element.offset().top + $element.height() - $($window).scrollTop()) + 10;
              $element.find('.products-menu').attr('style', 'max-height: calc(100vh - ' + maxHeight + 'px)');
            });
          }

          function findMatchString(value, str) {
            if (!value) { return; }
            if (!value.match || !value.replace) { value = value.toString(); }
            var matches, reg;

            var words = str.split(' '),
              tmp;
            _.each(words, function (word) {
              tmp = word.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
              if (tmp.length > 2) {
                reg = new RegExp(tmp, 'ig');
                matches = value.match(reg);
                if (matches) {
                  value = value.replace(reg, '##' + matches[0] + '#/#');
                }
              }
            });

            var open = new RegExp('##', 'g'),
              close = new RegExp('#/#', 'g');
            value = value.replace(open, '<span class="match">').replace(close, '</span>');
            return $sce.trustAsHtml(value).valueOf();
          }

        }]
      };
    });

})();
